/**
 * 深度合并对象
 */
export function deepMerge<T>(target: T, source: Partial<T>): T {
  const result = { ...target };

  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (
        source[key] &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key])
      ) {
        // @ts-ignore
        result[key] = deepMerge(
          result[key] as { [key: string]: any },
          source[key] as { [key: string]: any }
        );
      } else {
        result[key] = source[key] as any;
      }
    }
  }

  return result as T;
}